import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAwsAgentcore = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M20.3 6.3H14.4L11 9.7V14.7L7.7 18V23L10.6 25.9V30.2L14.1 33.7H16.8L20.3 36.4V6.3Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M20.3 11.6H16L14.2 13.4V16M7.7 20.5H12.6L15.4 23.3M20.3 20.2H17.6M20.3 27H16.6L14.5 29.1",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M29.4 14.3Q30.4 21 37 22Q30.4 23 29.4 29.7Q28.4 23 21.8 22Q28.4 21 29.4 14.3Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M35.4 6.6Q35.8 8.8 38 9.2Q35.8 9.6 35.4 11.8Q35 9.6 32.8 9.2Q35 8.8 35.4 6.6Z",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgAwsAgentcore);
export { ForwardRef as ReactComponent };
